import { create } from 'zustand';

interface ToastState { messages: { id: number; text: string }[]; push(text: string): void }
export const useToast = create<ToastState>((set) => ({
  messages: [],
  push: (text) => {
    const id = Date.now() + Math.random();
    set((state) => ({ messages: [...state.messages, { id, text }] }));
    window.setTimeout(() => set((state) => ({ messages: state.messages.filter((message) => message.id !== id) })), 3_000);
  },
}));

export function ToastViewport() {
  const messages = useToast((state) => state.messages);
  return <div className="toast-viewport" aria-live="polite">{messages.map((message) => <div className="toast" key={message.id}>{message.text}</div>)}</div>;
}
